import { render } from "./ButtonV2.vue?vue&type=template&id=c85b578c&scoped=true"
import script from "./ButtonV2.vue?vue&type=script&lang=js"
export * from "./ButtonV2.vue?vue&type=script&lang=js"

import "./ButtonV2.vue?vue&type=style&index=0&id=c85b578c&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c85b578c"]])

export default __exports__